<template>
  <section>
    <HeadingSmall>
      {{ $options.title }}
    </HeadingSmall>
    <ul class="jc-clearlist">
      <li
        :class="$style.option"
      >
        <Checkbox
          v-model="allowUsernameSubstring"
          data-test-id="passwordMayNotContainUsername"
          label="Allow username within password"
        />
      </li>
    </ul>
  </section>
</template>

<script>
import { Checkbox, HeadingSmall } from '@jumpcloud/ui-components';
import createComputedObjectBinding from 'client/util/createComputedObjectBinding';

const title = 'Password Originality';

export default {
  name: 'FieldsPasswordOriginality',

  components: {
    Checkbox,
    HeadingSmall,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    allowUsernameSubstring: {
      ...createComputedObjectBinding('allowUsernameSubstring'),
    },
  },

  title,
};
</script>

<style module>
.option {
  margin-bottom: var(--jc-spacer);
}
</style>
